import React from "react";
import "./resultCard.css";
import { Link } from "react-router-dom";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Avatar, Button } from "@material-ui/core";
import { ConvertDate } from "../../helper/math";
function ResultCard({
  songName,
  views,
  release,
  src,
  id,
  description,
  detail,
  videoDetail,
  isChannel,
  channelName,
}) {
  return (
    <div className="resultCard">
      <img src={src} alt={songName} />
      <Link
        to={`/watch?v=${id}`}
        onClick={() => videoDetail(detail)}
        className="resultCard__detail"
      >
        <div className="resulCard__top">
          <h3>
            {songName}
            <span>
              <MoreVertIcon />
            </span>
          </h3>

          <p>
            {views} . {ConvertDate(release)}
          </p>
        </div>
        <div className="resultCard__channel">
          <Avatar src="https://yt3.ggpht.com/a-/AOh14GiPEdxhVU6kfBTVaXPtyfF9KQfJy3kovA7vEQ=s68-c-k-c0x00ffffff-no-rj-mo" />
          <span> {channelName}</span>
          {isChannel && <Button disabled={isChannel} variant="outlined">Subscribe</Button>}
        </div>
        <div className="resultCard__des">
          <p>{description?.substring(0,50)}</p>
        </div>
      </Link>
    </div>
  );
}

export default ResultCard;
